module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datatable table-wrapper",
    class: _vm.tableClasses
  }, [_c('table', [_c('thead', {
    staticClass: "datatable-columns"
  }, [_c('tr', [(_vm.lineNumbers) ? _c('th', {
    style: ({
      width: _vm.lineColumnWidth
    })
  }, [_c('div', {
    staticClass: "datatable-column datatable-linenumber-column"
  }, [_vm._v("#")])]) : _vm._e(), _vm._v(" "), (_vm.aggregated) ? _c('th', {
    style: ({
      width: '100px'
    })
  }, [_c('div', {
    staticClass: "datatable-column datatable-aggregate-column"
  })]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)]), _vm._v(" "), (_vm.groupingColumnIds.length > 0) ? _c('tbody', {
    staticClass: "datatable-groups"
  }, [_c('tr', [_c('td', {
    staticClass: "datatable-groups-header",
    attrs: {
      "colspan": _vm.columnSpan
    }
  }, _vm._l((_vm.groupingColumns), function(column, index) {
    return _c('chip', {
      key: column.id,
      staticClass: "datatable-group-chip",
      on: {
        "remove": function($event) {
          _vm.degroupColumn(column)
        }
      }
    }, [_c('div', [_c('small', [_c('strong', [_vm._v(_vm._s(index == 0 ? "Grouping By:" : "Then:"))])])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(column.label))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('tbody', {
    staticClass: "datatable-collections"
  }, [_c('tr', [_c('td', {
    staticClass: "datatable-group",
    attrs: {
      "colspan": _vm.columnSpan
    }
  }, [_c('datatable-collection', {
    attrs: {
      "rows": _vm.rows,
      "columns": _vm.columns,
      "striped": _vm.striped,
      "editable": _vm.editable,
      "line-numbers": _vm.lineNumbers,
      "aggregated": _vm.aggregated,
      "grouping-columns": _vm.groupingColumnIds,
      "margin": _vm.lineColumnWidth,
      "message": _vm.message
    }
  })], 1)])]), _vm._v(" "), (_vm.aggregated) ? _c('tfoot', {
    staticClass: "datatable-aggregators"
  }, [_c('tr', [_c('td', {
    staticClass: "datatable-info-cell",
    attrs: {
      "colspan": _vm.columnSpan
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm.aggregators), function(aggregator, index) {
    return _c('tr', {
      key: aggregator.label
    }, [(_vm.lineNumbers) ? _c('td', {
      staticClass: "datatable-linenumber-cell"
    }, [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (_vm.aggregated) ? _c('td', {
      staticClass: "datatable-aggregate-cell"
    }, [_vm._v(_vm._s(aggregator.label))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
      return _c('td', {
        style: (column.columnStyles)
      }, [_vm._v(_vm._s(_vm.aggregate(column, aggregator)))])
    })], 2)
  })], 2) : _vm._e()], 1), _vm._v(" "), (_vm.filterable) ? _c('div', {
    staticClass: "datatable-options",
    attrs: {
      "layout": "row center-justify"
    }
  }, [(_vm.optimize) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.filter),
      expression: "filter",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Filter this dataset. Press enter to search...",
      "self": "size-x1"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "change": function($event) {
        _vm.filter = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Filter this dataset...",
      "self": "size-x1"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24f1a1d0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Datatable/datatable.vue
// module id = 2122
// module chunks = 0